<script>
import Layout from "../../_layouts/main"
import PageHeader from "@/components/page-header"
import Document from '../../../components/api/document'

/**
 * Dashboard Component
 */
export default {
  components: {
    Layout,
    PageHeader,
    Document
  },
  data() {
    return {
      title: this.$t('회원가입'),
      apiUrl: process.env.VUE_APP_API_SERVER_URL + 'register',
      response: '',
      body: {
        username: { type: 'text', value: 'user1', desc: this.$t('text.api.username_desc'), required: true, length: '1~21' },
        siteUsername: { type: 'text', value: 'user1', desc: this.$t('text.api.siteUsername_desc'), required: true, length: '1~21' },
        groupKey: { type: 'text', value: 'shop1', desc: this.$t('text.api.groupKey_desc'), length: '1~32' }
      }
    };
  },
  mounted() {
    /*
    let host = location.host
    if (host.indexOf('localhost') > -1 || host.indexOf('127.0.0.1') > -1) {
      host = 'http://127.0.0.1:39011/'
    } else {
      host = `https://api.${host}/`
    }

     */
    const host = process.env.VUE_APP_API_SERVER_URL
    this.apiUrl = host + 'register'

    // 응답값 설정
    this.response = '{\n' +
        ' "code": 0, // 응답값(0이 아니면 오류)\n' +
        ' "id": "63133b14fbe0f85db2764950", // 회원코드\n' +
        ' "username": "top1_user1", // API 회원아이디\n' +
        ' "siteUsername": "user1" // 사이트 회원아이디\n' +
        '}'
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="card-title"><span class="badge bg-primary">요청 URL</span> {{ apiUrl }}</div>
            <div class="card-title-desc">신규 회원을 등록합니다.</div>
            <hr/>
            <Document :data="body" :apiUrl="apiUrl" :response="response" :require-vendors="false" :require-ip-address="true" :require-request-key="true" />
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
